import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { withRouter } from '../withRouter';
import styles from 'components/Room/RedirectListener.module.scss';
import DotLoader from 'components/Utlility/DotLoader';
import LogoWhite from 'images/logo-white.png';
import { findPlayableGameById } from 'constants/GameListAdapter';


class RedirectListener extends Component {
    static displayName = RedirectListener.name;

    constructor(props) {
        super(props);

        this.state = {
           doRedirect: false,
        };
    }

    componentDidMount() {
       
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.props.room.startingGame === true && prevProps.room.startingGame === false) {
            const redirectInfo = this.props.room.redirectInfo;

            // External games have their own loading screens, so redirect immediately
            // Internal games show "Starting Game" for 1.5s for a smoother transition
            const delay = redirectInfo.isExternalGame ? 100 : 1500;
            setTimeout(() => {
                this.setState({ doRedirect: true, });
                // Disable SDK auto-reconnect before navigation. Browser closing the
                // WebSocket sends code 1001 (GOING_AWAY) which normally triggers
                // the 0.17 SDK's auto-reconnect. Setting maxRetries=0 prevents this.
                // Server's onDrop will allow reconnection from the game subdomain.
                this.props.room.room.reconnection.maxRetries = 0;
            }, delay);
        }
    }

    getGameId = () => {
        return this.props.room.redirectInfo.gameId
    }

    // Hardcoded backgrounds for rich branded loading screens (images, gradients).
    // Falls back to CMS gameMenuBackgroundColour for new games not listed here.
    getGameBackground = (id) => {
        switch (id) {
            case 'scrawl':
                return styles.scrawl;
            case 'herd_mentality':
                return styles.herdMentality;
            case 'can_of_squirms':
                return styles.canOfSquirms;
            case 'draw_with':
                return styles.drawAlongWithDave;
            case 'chameleon':
                return styles.theChameleon;
            case 'colour_brain':
                return styles.colourBrain;
            case 'pub_quiz':
                return styles.pubQuiz;
            case 'anagram_magic':
                return styles.anagramMagic;
            case 'maths_master':
                return styles.mathsMaster;
            case 'word_wheel':
                return styles.wordWheel;
            case 'cant_say_umm':
                return styles.cantSayUmm;
            case 'catchphrase':
                return styles.catchphrase;
            case 'universally_challenged':
                return styles.uniChal;
            case 'poker':
                return styles.poker;
            case 'pointless':
                return styles.pointless;
            case 'songblast':
                return styles.songblast;
            default:
                return null;
        }
    }

    // CMS fallback: inline background style for games without hardcoded SCSS
    getCmsBackgroundStyle = (id) => {
        const game = findPlayableGameById(id);
        const bgColour = game?.meta?.gameMenuBackgroundColour;
        if (bgColour) {
            return { backgroundColor: bgColour };
        }
        return null;
    }

    // Hardcoded text colors for branded loading screens.
    // Falls back to CMS gameMenuTextColour for new games not listed here.
    getGameTextColor = (id) => {
        switch (id) {
            case 'scrawl':
                return '#EC0080';
            case 'herd_mentality':
                return '#E56DA6';
            case 'can_of_squirms':
                return '#212B3D';
            case 'draw_with':
                return '#FFFFFF';
            case 'chameleon':
                return '#F7EE69';
            case 'colour_brain':
                return '#10232B';
            case 'pub_quiz':
                return '#FFFFFF';
            case 'anagram_magic':
                return '#002026';
            case 'maths_master':
                return '#002026';
            case 'word_wheel':
                return '#002026';
            case 'catchphrase':
                return '#1e236e';
            case 'universally_challenged':
                return '#FFFFFF';
            case 'songblast':
                return '#FFFFFF';
            default: {
                // CMS fallback for new games
                const game = findPlayableGameById(id);
                return game?.meta?.gameMenuTextColour || '#FFFFFF';
            }
        }
    }

    render() {
        const startingGame = this.props.room.startingGame;
        const gameURL = this.props.room.redirectInfo.gameURL;
        const isHost = this.props.room.redirectInfo.isHost;
        const sessionId = this.props.room.redirectInfo.sessionId;
        const roomId = this.props.room.redirectInfo.roomId;
        const token = this.props.room.redirectInfo.reconnectionToken;
        const isExternalGame = this.props.room.redirectInfo.isExternalGame;
        let isInApp = localStorage.getItem('isAppView')
        console.log("IS APP VIEW:", isInApp)

        let redirectURL;
        if (isExternalGame) {
            // External games (e.g., SongBlast) already have complete URLs with room code
            redirectURL = gameURL;
            if (isInApp) {
                redirectURL += (redirectURL.includes('?') ? '&' : '?') + 'isInApp=true';
            }
        } else {
            // Internal games - build URL with client path and token
            redirectURL = gameURL;
            if (!isHost) {
                redirectURL += "/client"
            }
            redirectURL += `?token=${token}`;
            if (isInApp) {
                redirectURL += `&isInApp=true`;
            }
            if (this.props.room.isMirror) {
                redirectURL += `&mirror=true`;
            }
        }

        if (startingGame && this.state.doRedirect) {
            window.location = redirectURL;
        }

        
        const gameId = this.getGameId();
        const hardcodedBg = this.getGameBackground(gameId);
        // If no hardcoded SCSS class, fall back to CMS background color
        const cmsBgStyle = !hardcodedBg ? this.getCmsBackgroundStyle(gameId) : null;

        // External games show a loading screen that matches SongBlast's preloader
        if (isExternalGame) {
            return (
                <div className={`${styles.startingGameWrapper} ${hardcodedBg || ''} ${startingGame && styles.show}`} style={cmsBgStyle}>
                    <div className={styles.externalGameLoading}>
                        <img src={LogoWhite} className={styles.gcLogo} alt="Game City" />
                        <div className={styles.pulsingDots}>
                            <span className={styles.dot}></span>
                            <span className={styles.dot}></span>
                            <span className={styles.dot}></span>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={`${styles.startingGameWrapper} ${hardcodedBg || ''} ${startingGame && styles.show}`} style={cmsBgStyle}>
                <div className={styles.startingGameInner}>
                    {/*<img src={LogoWhite} style={{ width: "20vh", height: "auto", marginBottom: "1vh" }} alt="loading" />*/}
                    <h2 style={{ color: this.getGameTextColor(gameId) }}>Starting Game</h2>
                    <DotLoader size="large" variant="light" />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

export default connect(mapStateToProps, null)(withRouter(RedirectListener));
